const types = {
    INSTRUCTIONS_SUCCESS: "INSTRUCTIONS_SUCCESS"
}

export default types;